/**
 * Trạng thái của form
 */
export default {
  Female: 1,
  Male: 0,
  Other: null,
};
